module.exports = __webpack_public_path__ + "img/menu__banner.c77a4b1c.png";